<template>

  <div class="page">
    <div class="main">
      <!-- 頁面抬頭-->
      <section class="title-cover">
        <!-- 頁面標題-->
        <picture class="title-img"> <img src="../assets/awardTW/img/title918.png"></picture>
      </section>
      <section class="awards awards-1st">
        <picture class="title-img"><img src="../assets/awardTW/img/no1.png"></picture>
        <ul class="awards-list">
          <li> <span class="name">呂先生</span><span class="number">*******524</span></li>
        </ul>
        <picture class="awards-img"><img src="../assets/awardTW/img/no1-CAR.png"><img style="margin: -5% auto -25%;z-index: -1;"
            src="../assets/awardTW/img/bg-fifa.png"></picture>
      </section>
      <!-- 影片區-->
      <!-- <section class="video-cover"> -->
        <!-- <picture class="title-img"><img src="../assets/awardTW/img/video-title.png"></picture>
        <div class="video-box"><iframe width="1280" height="720" src="https://www.youtube.com/embed/Z4VUFv6jvSs"
            title="FULL MATCH: Italy vs. France 2006 FIFA World Cup" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe></div> -->
      <!-- </section> -->
      <section class="awards-cover">
        <!-- 2等獎-->
        <section class="awards awards-2st">
          <picture class="title-img"><img src="../assets/awardTW/img/no2.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">李先生</span><span class="number">*******988</span></li>
            <li> <span class="name">賴先生</span><span class="number">*******650</span></li>
            <li> <span class="name">黃先生</span><span class="number">*******541</span></li>
          </ul>
        </section>
        <!-- 3等獎-->
        <section class="awards awards-3st">
          <picture class="title-img"><img src="../assets/awardTW/img/no3.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">葉先生</span><span class="number">*******474</span></li>
            <li> <span class="name">魏先生</span><span class="number">*******349</span></li>
            <li> <span class="name">楊小姐</span><span class="number">*******586</span></li>
            <li> <span class="name">康先生</span><span class="number">*******255</span></li>
            <li> <span class="name">王先生</span><span class="number">*******188</span></li>
            <li> <span class="name">陳先生</span><span class="number">*******238</span></li>
          </ul>
        </section>
        <!-- 4等獎-->
        <section class="awards awards-4st">
          <picture class="title-img"><img src="../assets/awardTW/img/no4.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">白先生</span><span class="number">*******376</span></li>
            <li> <span class="name">葉先生</span><span class="number">*******924</span></li>
            <li> <span class="name">林先生</span><span class="number">*******533</span></li>
            <li> <span class="name">楊先生</span><span class="number">*******324</span></li>
            <li> <span class="name">董先生</span><span class="number">*******926</span></li>
            <li> <span class="name">王先生</span><span class="number">*******577</span></li>
            <li> <span class="name">白先生</span><span class="number">*******202</span></li>
            <li> <span class="name">張小姐</span><span class="number">*******614</span></li>
          </ul>
        </section>
        <!-- 5等獎-->
        <section class="awards awards-5st">
          <picture class="title-img"><img src="../assets/awardTW/img/no5.png"></picture>
          <ul class="awards-list">
            <li> <span class="name">白先生</span><span class="number">*******256</span></li>
            <li> <span class="name">江先生</span><span class="number">*******376</span></li>
            <li> <span class="name">林先生</span><span class="number">*******483</span></li>
            <li> <span class="name">蔡先生</span><span class="number">*******403</span></li>
            <li> <span class="name">鄧先生</span><span class="number">*******991</span></li>
            <li> <span class="name">廖先生</span><span class="number">*******929</span></li>
            <li> <span class="name">李先生</span><span class="number">*******102</span></li>
            <li> <span class="name">羅先生</span><span class="number">*******260</span></li>
          </ul>
        </section>
      </section>
      <!-- 廠商-->
      <ul class="manufacturers-list">
        <li><img src="../assets/awardTW/img/logo-OB.png"></li>
        <li><img src="../assets/awardTW/img/logo-BWIN.png"></li>
        <li><img src="../assets/awardTW/img/logo-DBG.png"></li>
        <li><img src="../assets/awardTW/img/logo-QT.png"></li>
        <li><img src="../assets/awardTW/img/logo-GR.png"></li>
        <li><img src="../assets/awardTW/img/logo-BNG.png"></li>
        <li><img src="../assets/awardTW/img/logo-SA.png"></li>
      </ul>
    </div>
    <article class="btn-box"> <a class="btn btn-goHome" a href="https://www.ofa918.net"><img
          src="../assets/awardTW/img/icon-goHome.svg"></a></article>
  </div>
</template>

<script>
export default {

  data() {
    return {

    };
  },
}
</script>


<style scoped>
@import '../assets/awardTW/css/style.css';
</style>



// WEBPACK FOOTER //
// src/components/award918.vue